import { render, staticRenderFns } from "./pay-code.vue?vue&type=template&id=0b246f89&scoped=true"
import script from "./pay-code.vue?vue&type=script&lang=js"
export * from "./pay-code.vue?vue&type=script&lang=js"
import style0 from "./pay-code.vue?vue&type=style&index=0&id=0b246f89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b246f89",
  null
  
)

export default component.exports